import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { LoanMetadataEditForm } from '../LoanMetadataEditForm';
import { LoanEditRouteParamsStruct } from '../types';
import { NavigationSideBar } from './NavigationSidebar';
import { ReviewHeaderBar } from './ReviewHeaderBar';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { dashboardRoutePadding } from '~/packages/common-frontend/constants';

const RouteBase = () => {
  return (
    <Flex w="100%">
      <NavigationSideBar />
      <Flex
        flexDirection="column"
        alignItems="flex-start"
        gap="2rem"
        padding={dashboardRoutePadding}
        flexGrow={1}
      >
        <ReviewHeaderBar />

        <Flex width="100%" justify="space-between" alignItems="center">
          <Typography variant="page-title" trim>
            Review Changes
          </Typography>
        </Flex>
        <Typography variant="base-muted">
          Use the left navigation to review edits, which are shown by default.
          Hover over modified fields to see previous values. Use ‘Mark as
          Reviewed’ to track progress; it is not required to submit for
          approval. Select ‘Submit for Approval’ or ‘Return to Editing’ to make
          additional changes.
        </Typography>

        <LoanMetadataEditForm readOnly />
      </Flex>
    </Flex>
  );
};

export const Route = () => {
  const params = useParams();
  const { loanId } = LoanEditRouteParamsStruct.parse(params);

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message, { duration: 12000 });
        return <Navigate to={`/loans/${loanId}`} />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
